import _ from 'lodash';
import { makeAutoObservable, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useCommonNavigate } from '../../common/CommonLink';
import { ReportResponse } from '../../../../server/response/responseScheme';
import currencyStore from '../../../stores/currencyStore';
import Table from '../../../uikit/Table';
import { apiClient } from '../../../utils/apiClient';
import { useMobxInstance } from '../../../utils/mobxUtil';
import stringUtil from '../../../utils/stringUtil';

class ViewStore {
    readonly institutionSlug: string | undefined;

    reportList: ReportResponse[] = [];

    constructor(institutionSlug: string | undefined) {
        this.institutionSlug = institutionSlug;

        makeAutoObservable(this);
    }

    async fetch() {
        if (!this.institutionSlug) {
            return;
        }

        const reportList = await apiClient.report.public.getReportList.$query({
            institutionSlug: this.institutionSlug,
        });

        runInAction(() => {
            this.reportList = reportList;
        });
    }
}

const ReportListTable = observer(({ institutionSlug }: { institutionSlug: string }) => {
    const { navigate } = useCommonNavigate();

    const viewStore = useMobxInstance(ViewStore, institutionSlug);

    useEffect(() => {
        viewStore.fetch();
    }, [viewStore]);

    return (
        <Table>
            <Table.Header className="text-left tabular-nums">연도</Table.Header>
            <Table.Header className="text-left tabular-nums">분기</Table.Header>
            <Table.Header className="text-right">보유 종목</Table.Header>
            <Table.Header className="text-right">보유 자산</Table.Header>

            {_.map(viewStore.reportList, (report) => {
                return (
                    <Table.Row
                        key={report.hash}
                        onClick={() => {
                            navigate(
                                `/portfolio/${viewStore.institutionSlug}/report/${report.reportYear}/${report.reportQuarter}`,
                            );
                        }}
                    >
                        <Table.Cell className="text-base-content/70 text-left tabular-nums">
                            {report.reportYear}년
                        </Table.Cell>
                        <Table.Cell className="text-base-content/70 text-left tabular-nums">
                            {report.reportQuarter}분기
                        </Table.Cell>
                        <Table.Cell className="text-right text-base tabular-nums">
                            {stringUtil.toCommaNumber(report.totalHolding)}개
                        </Table.Cell>
                        <Table.Cell className="text-right text-base tabular-nums">
                            {currencyStore.toCompactUsdOrKrw(Number(report.totalValue) * 1000)}
                        </Table.Cell>
                    </Table.Row>
                );
            })}
        </Table>
    );
});

export default ReportListTable;
